export default "__VITE_ASSET__266e2a09__"